import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';
import { CategoriesComponent } from './pages/categories/categories.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { ProductsComponent } from './pages/products/products.component';
import { StoreComponent } from './pages/store/store.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';

const routes: Routes = [{
  path: 'login',
  component: LoginComponent,
},
{
  path: 'home',
  component: HomeComponent,
  canActivate: [AuthGuard]
},
{
  path: 'categories',
  component: CategoriesComponent,
  canActivate: [AuthGuard]
},
{
  path: 'products',
  component: ProductsComponent,
  canActivate: [AuthGuard]
},
{
  path: 'store',
  component: StoreComponent,
  canActivate: [AuthGuard]
},
{
  path: 'privacy-policy',
  component: PrivacyPolicyComponent
},
{
  path: '', redirectTo: 'home', pathMatch: 'full'
},
{
  path: '**', redirectTo: ''
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

